export default (field, files) => ({

    field: field,
    existingFiles: files,
    selectedFile: '',
    selectedFiles: [],
    uploadedFiles: [],

    uploadFiles(fileList) {
        this.uploadedFiles.push(...fileList);
    },

    addSelectedFile() {
        this.selectedFiles.push(this.selectedFile.replace('/content/',''));
        this.selectedFile = '';
    },

    removeExistingFile(index) {
        this.existingFiles.splice(index, 1);
    },

    removeSelectedFile(index) {
        this.selectedFiles.splice(index, 1);
    },

    removeUploadedFile(index) {
        this.uploadedFiles.splice(index, 1);
    },

    renderPreview(element, file) {

        let reader = new FileReader();
        reader.readAsDataURL(file);

        reader.addEventListener('load', function () {
            // convert image file to base64 string
            element.src = reader.result;
        }, false);

        return '';
    },
})
